import React from 'react'

import './top-level-fallback-error.scss'

const baseClass = 'top-level-fallback-error'

const TopLevelFallbackError = ({ error }) => {
  return (
    <div className={baseClass}>
      <div className={`${baseClass}__content`}>
        <h1 className={`${baseClass}__title`}>Something went wrong</h1>
        <h2 className={`${baseClass}__subtitle`}>Occasionally things break, please try reload the app.</h2>
        { process.env.NODE_ENV === 'development' && (
          <code className='block h-[50vh] overflow-auto'>
            {JSON.stringify(error, Object.getOwnPropertyNames(error), 2)}
          </code>
        )}
        <button
          className={`${baseClass}__button`}
          onClick={() => location.reload()}>
          Reload
        </button>
      </div>
    </div>
  )
}

export { TopLevelFallbackError }
